import { Flag as FlagIcon } from '@mui/icons-material';

const Flag = (): JSX.Element => <FlagIcon fontSize="inherit" />;

export default Flag;
